import { render, staticRenderFns } from "./GrayRouteConfig.vue?vue&type=template&id=6065a013&scoped=true"
import script from "./GrayRouteConfig.vue?vue&type=script&lang=js"
export * from "./GrayRouteConfig.vue?vue&type=script&lang=js"
import style0 from "./GrayRouteConfig.vue?vue&type=style&index=0&id=6065a013&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065a013",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6065a013')) {
      api.createRecord('6065a013', component.options)
    } else {
      api.reload('6065a013', component.options)
    }
    module.hot.accept("./GrayRouteConfig.vue?vue&type=template&id=6065a013&scoped=true", function () {
      api.rerender('6065a013', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cfg/GrayRouteConfig.vue"
export default component.exports